import React from 'react';
import {Route} from 'react-router-dom';
import {SessionManager} from "../../session-manager";

export class PublicComponent extends React.Component {
    render() {
        return SessionManager.isAuthenticated() ? '' : <Route {...this.props} />
    }
}